<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-start wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-layout
            :justify-start="$vuetify.breakpoint.name !== 'xs' ? true : false"
            :justify-center="$vuetify.breakpoint.name == 'xs' ? true : false"
            wrap
            pt-6
          >
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md2 pl-3 text-center>
                <v-icon>mdi-account-plus-outline</v-icon>
              </v-flex>
              <v-flex xs9 sm9 md10 text-left>
                <span
                  style="
                    font-family: nunitosansbold;
                    font-size: 20px;
                    color: #000000;
                  "
                  >Add New Staff</span
                >
              </v-flex>
            </v-layout>
            <v-flex xs6 sm6 md8 text-left>
              <router-link :to="'/staffList'" style="text-decoration: none">
                <span
                  style="
                    color: #797979;
                    font-family: nunitosanssemibold;
                    font-size: 18px;
                  "
                  >Staff List</span
                >
              </router-link>
            </v-flex></v-layout
          >
          <v-card-text>
            <v-layout justify-start wrap>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="staff.firstName"
                  class="text"
                  label="First Name"
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="staff.lastName"
                  class="text"
                  label="Last Name"
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-center wrap>
              <v-flex xs12 text-center>
                <v-flex xs12 v-if="file">
                  <span>{{ file.name }}</span>
                </v-flex>
              </v-flex>
              <v-flex xs12 md4 offset-md4>
                <v-btn
                  block
                  small
                  dark
                  height="50px"
                  color="#9B8DFD"
                  @click="$refs.showFile.click()"
                >
                  <v-icon style="color: #ffffff">mdi-note-text-outline</v-icon>
                  <span style="font-family: nunitosanssemibold"
                    >UPLOAD STAFF INFO SHEET</span
                  >
                </v-btn>
                <input
                  v-show="false"
                  id="file"
                  ref="showFile"
                  multiple="multiple"
                  type="file"
                  @change="showFile"
                />
                <v-layout justify-center wrap pt-2>
                  <v-flex xs12 text-center>
                    <span style="font-family: nunitosansregular; color: #8f8f8f"
                      >Upload One or Multiple Staff Data</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md4 py-2 text-right>
                <a
                  :href="'http://52.66.213.94/u/1625479732800.xlsx'"
                  style="text-decoration: none"
                >
                  <v-btn small plain color="#9B8DFD">
                    <span>Download Template</span>
                    <v-icon>mdi-download-outline</v-icon>
                  </v-btn>
                </a>
              </v-flex>
            </v-layout>
            <v-layout justify-start wrap pt-12>
              <v-flex xs12 pl-2>
                <span style="color: #000000; font-family: nunitosansbold"
                  >Add Staff Information</span
                >
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  dense
                  label="Gender"
                  outlined
                  class="text"
                  v-model="staff.gender"
                  :items="genders"
                  hide-details
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="staff.dob"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="staff.dob"
                      label="DOB"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="staff.dob" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(staff.dob)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="staff.subject1"
                  class="text"
                  label="Subject"
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="staff.subject2"
                  class="text"
                  label="Subject 2"
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="staff.email"
                  :rules="emailRules"
                  class="text"
                  label="Email"
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="staff.phone"
                  class="text"
                  label="Contact"
                  outlined
                  type="number"
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-2>
                <v-text-field
                  v-model="staff.address"
                  class="text"
                  label="Address"
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="staff.emergencyName"
                  class="text"
                  label="Emergency Name"
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="staff.emergencyContact"
                  class="text"
                  label="Emergency Contact"
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="staff.emergencyEmail"
                  class="text"
                  label="Emergency Email"
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-start wrap pl-2 pb-5>
              <v-flex xs12>
                <img
                  v-if="imagePreview"
                  :src="imagePreview"
                  v-show="showPreview"
                  width="150px"
                  height="150px"
                  class="align-center"
                  contain
                />
              </v-flex>
              <v-flex xs12 sm7 md5 lg4>
                <v-btn
                  width="180px"
                  block
                  tile
                  depressed
                  :ripple="false"
                  class="text-capitalize"
                  color="#F6F5FF"
                  @click="$refs.showImage.click()"
                >
                  <v-layout justify-center wrap>
                    <v-flex xs2 sm2 md2>
                      <v-icon style="color: #000000">mdi-upload</v-icon>
                    </v-flex>
                    <v-flex xs10 sm8 md8>
                      <span
                        style="
                          font-family: nunitosanssemibold;
                          font-size: 12px;
                          color: #020202;
                        "
                        >UPLOAD PROFILE PICTURE
                      </span>
                    </v-flex>
                  </v-layout>
                </v-btn>
                <input
                  v-show="false"
                  accept="image/*"
                  id="file"
                  ref="showImage"
                  multiple="multiple"
                  type="file"
                  @change="showImage"
                />
              </v-flex>
            </v-layout>
            <v-layout justify-center wrap py-8>
              <v-flex xs12 sm6 md4>
                <v-btn
                  block
                  @click="validateInput"
                  dark
                  height="50px"
                  color="#9B8DFD"
                >
                  <span style="font-family: nunitosanssemibold">SUBMIT</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      staff: {
        firstName: "",
        lastName: "",
        gender: "",
        dob: "",
        email: "",
        phone: "",
        address: "",
        subject1: "",
        subject2: "",
        name: "teacher",
        emergencyName: "",
        emergencyContact: "",
        emergencyEmail: "",
      },
      menu: false,
      showsnackbar: false,
      showPreview: false,
      filePreview: false,
      showFilePreview: false,
      file: null,
      file1: null,
      imagePreview: "",
      image: "",
      id: "",
      hover: false,
      appLoading: false,
      ServerError: false,
      msg: "",
      timeout: 5000,
      studentList: [],
      page: 1,
      classArray: [],
      genders: ["Male", "Female", "Other"],
      emailRules: [
        (v) => !!v || "Email is Required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  mounted() {
    if (this.staff) this.staff.dob = "2016-01-01";
  },
  methods: {
    validateInput() {
      if (!this.staff.firstName) {
        this.msg = "Please Provide First name";
        this.showsnackbar = true;
        return;
      } else if (!this.staff.lastName) {
        this.msg = "Please Provide Last name";
        this.showsnackbar = true;
        return;
      } else if (!this.staff.gender) {
        this.msg = "Please Provide Gender";
        this.showsnackbarr = true;
        return;
      } else if (!this.staff.phone) {
        this.msg = "Please Provide Phone";
        this.showsnackbar = true;
        return;
      } else if (this.staff.phone.length != 10) {
        this.msg = "Please enter valid number";
        this.showsnackbar = true;
        return;
      } else if (!this.staff.email) {
        this.msg = "Please Provide Email";
        this.showsnackbar = true;
        return;
      } else if (!this.staff.dob) {
        this.msg = "Please Provide Date of Birth";
        this.showsnackbar = true;
        return;
      } else if (!this.staff.address) {
        this.msg = "Please Provide Address";
        this.showsnackbar = true;
        return;
      } else if (!this.staff.emergencyName) {
        this.msg = "Please Provide Emergency Name";
        this.showsnackbar = true;
        return;
      } else if (!this.staff.emergencyContact) {
        this.msg = "Please Provide Emergency Contact";
        this.showsnackbar = true;
        return;
      } else if (this.staff.emergencyContact.length != 10) {
        this.msg = "Please enter valid emergency number";
        this.showsnackbar = true;
        return;
      } else if (!this.staff.emergencyEmail) {
        this.msg = "Please Provide Emergency Email";
        this.showsnackbar = true;
        return;
      } else if (!this.imagePreview) {
        this.msg = "Please Upload Photo";
        this.showsnackbar = true;
        return;
      } else {
        this.addStaff();
      }
    },
    addStaff() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/teacher/add",
        data: this.staff,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Staff Added Successully";
            this.id = response.data.data._id;
            if (this.imagePreview && this.id) {
              this.uploadImage(this.id);
            }
            Object.keys(this.staff).forEach((key) => (this.staff[key] = null));
            this.$router.push({ path: "/staffList" });
            this.getData();
            this.showsnackbar = true;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    showFile(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.filePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showFilePreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        this.uploadFile();
      }
    },
    uploadFile() {
      let formData = new FormData();
      formData.append("doc", this.file);
      axios({
        method: "POST",
        url: "/excelimport/staff/upload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.file = null;
            this.filePreview = null;
            this.showFilePreview = null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.msg = "Can't Upload Image.. Please Try Again Later";
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    showImage(e) {
      this.file1 = e.target.files[0];
      console.log(e);
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file1.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreview = true;
      if (this.file1) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file1.name)) {
          reader.readAsDataURL(this.file1);
        }
      }
    },
    uploadImage(sid) {
      let formData = new FormData();
      formData.append("photo", this.file1);
      formData.append("id", sid);
      axios({
        method: "POST",
        url: "/User/adminUploadImage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.showPreview = null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.text {
  color: #5d5d5d;
  font-family: nunitosansregular;
}
.dottedline {
  border: none;
  border-top: 2px dashed rgb(208, 208, 208);
  color: #8181812f;
  /* background-color:#8181812F; */
  height: 1px;
  width: 100%;
}
</style>